import { render } from "./VideoQuizResultsComponent.vue?vue&type=template&id=9af9b016&scoped=true"
import script from "./VideoQuizResultsComponent.vue?vue&type=script&lang=js"
export * from "./VideoQuizResultsComponent.vue?vue&type=script&lang=js"

import "./VideoQuizResultsComponent.vue?vue&type=style&index=0&id=9af9b016&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af9b016"]])

export default __exports__